<template>
  <main-content>
    <kt-panel>
      <kt-panel-header>
        <kt-panel-header-label>
          <kt-panel-header-title>
            تنظیمات احراز هویت کاربران
          </kt-panel-header-title>
        </kt-panel-header-label>
      </kt-panel-header>
      <kt-panel-body>
        <form class="kt-form" @submit.prevent="update">
          <kt-form-section>
            <kt-form-row>
              <kt-col lg="4" md="4" sm="12">
                <kt-form-group>
                  <kt-form-label for="provider">
                    {{ $t('label.provider') }}
                  </kt-form-label>
                  <select id="provider"
                          name="provider"
                          class="form-control kt-selectpicker"
                          v-model="provider">
                    <option v-for="(prov, index) in providers" :key="index" :value="prov">
                      {{ prov }}
                    </option>
                  </select>
                </kt-form-group>
              </kt-col>
            </kt-form-row>
          </kt-form-section>
          <kt-form-action class="mt-2">
            <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
              {{ $t('btn.submit') }}
            </button>
          </kt-form-action>
        </form>
      </kt-panel-body>
    </kt-panel>
  </main-content>
</template>

<script>
import mainContent from "../../components/main-content.vue";
import {userService} from "../../common/api.service";
import toastr from "toastr";

export default {
  components: {
    'main-content': mainContent
  },
  data() {
    return {
      provider: null,
      providers: [],
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }
      return toastr
    },
  },
  methods: {
    update() {
      userService.updateUserAuthenticationSettings({ provider: this.provider })
          .then(response => {
            this.toastr.success(response.data.message);
          })
          .catch(({response}) => {
            this.toastr.error(response.data.message);
          })
    }
  },
  mounted() {
    userService.getUserAuthenticationSettings()
        .then(response => {
          this.providers = response.data.data.providers;
          this.provider = response.data.data.provider;
        })
  }
}
</script>

<style scoped>

</style>